import { getThemeColor, Gift } from '@sparemin/blockhead';
import styled from 'styled-components';

export const GiftIcon = styled(Gift)`
  color: ${getThemeColor('white')};
`;
